<ui-checkbox class="tree-node-checkbox" [uiChecked]="isChecked" [uiIndeterminate]="isHalfChecked" [uiDisabled]="isDisableCheckbox" (handleClick)="checkChange.emit($event)"></ui-checkbox>
